export const DEFAULT_CHAT_FILTERS = { is_closed: false } as const;
